import { PATIENT_ONBOARDING_ROUTING_CONFIG } from '@uplift/constants';

type OnboardingRoutingConfig = typeof PATIENT_ONBOARDING_ROUTING_CONFIG;
type Routes = OnboardingRoutingConfig[keyof OnboardingRoutingConfig];

export const syncRouteInvocation = (route: Routes, options?: { replace?: boolean }) => (({
  src: 'syncRouteActor',
  input: { route, replace: options?.replace }
}) as const);

export const MATCHES_LOADING_DURATION = 3500;

const WELCOME_STEP_AB_COOKIE_NAME = 'welcome-step-ab';
const WELCOME_STEP_DAYS_TO_EXPIRE = 30;

export const shouldShowWelcomeStepAB = (): boolean => {
  const match = document.cookie.match(new RegExp('(^| )' + WELCOME_STEP_AB_COOKIE_NAME + '=([^;]+)'));

  // if cookie is set, return the value
  if (match) {
    return match[2] === 'true';
  }

  // if cookie is not set, set it and return it
  const abValue = Math.random() < 0.5;
  const expires = new Date(Date.now() + WELCOME_STEP_DAYS_TO_EXPIRE * 24 * 60 * 60 * 1000).toUTCString();

  document.cookie = `${WELCOME_STEP_AB_COOKIE_NAME}=${abValue}; expires=${expires}; path=/; SameSite=Lax${document.location.hostname.includes('localhost') ? '' : '; Secure'}`;

  return abValue;
};